var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTable(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 21,
    viewBox: "0 0 25 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 6H18.5V1.5C18.5 0.675 17.825 0 17 0H2C1.175 0 0.5 0.675 0.5 1.5V13.5C0.5 14.325 1.175 15 2 15H6.5V19.5C6.5 20.325 7.175 21 8 21H23C23.825 21 24.5 20.325 24.5 19.5V7.5C24.5 6.675 23.825 6 23 6ZM15.5 4.5V7.5H9.5V4.5H15.5ZM15.5 13.5H9.5V9H15.5V13.5ZM3.5 4.5H8V7.5H3.5V4.5ZM3.5 12V9H8V12H3.5ZM9.5 18V15H15.5V18H9.5ZM21.5 18H17V15H21.5V18ZM21.5 13.5H17V10.5H21.5V13.5Z",
    fill: "#D8DAE5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTable);
export default __webpack_public_path__ + "static/media/table.514ceac2dfc236b7529ed2fadfc111f2.svg";
export { ForwardRef as ReactComponent };